/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

gbc.constants.nodeAttributes = {
  Action: [
    "acceleratorName",
    "acceleratorName2",
    "acceleratorName3",
    "acceleratorName4",
    "active",
    "comment",
    "contextMenu",
    "context",
    "defaultView",
    "helpNum",
    "hidden",
    "idRef",
    "image",
    "name",
    "tabIndexRt",
    "tag",
    "text",
    "validate"
  ],
  ActionDefault: [
    "acceleratorName",
    "acceleratorName2",
    "acceleratorName3",
    "acceleratorName4",
    "comment",
    "contextMenu",
    "defaultView",
    "idRef",
    "image",
    "name",
    "tag",
    "text",
    "validate"
  ],
  ActionDefaultList: ["fileName", "idRef", "name", "tag"],
  Aggregate: [
    "aggregateText",
    "aggregateType",
    "blink",
    "bold",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fieldIdRef",
    "fontPitch",
    "format",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "name",
    "posX",
    "posY",
    "reverse",
    "sample",
    "sizePolicy",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "width",
    "stretchMin",
    "stretchMax"
  ],
  Button: [
    "acceleratorName",
    "actionActive",
    "actionIdRef",
    "cloneColumns",
    "cloneCount",
    "comment",
    "disclosureIndicator",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "image",
    "name",
    "posX",
    "posY",
    "sample",
    "sizePolicy",
    "stepX",
    "stepY",
    "stretch",
    "stretchMin",
    "style",
    "tabIndex",
    "tabIndexRt",
    "tag",
    "text",
    "width"
  ],
  ButtonEdit: [
    "action",
    "actionActive",
    "actionIdRef",
    "autoNext",
    "blink",
    "bold",
    "century",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "format",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "image",
    "isPassword",
    "justify",
    "keyboardHint",
    "maxLength",
    "name",
    "notEditable",
    "picture",
    "placeholder",
    "posX",
    "posY",
    "program",
    "reverse",
    "sample",
    "scroll",
    "shift",
    "sizePolicy",
    "stretch",
    "stretchMin",
    "stretchMax",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "verify",
    "width"
  ],
  Canvas: [
    "comment",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "name",
    "posX",
    "posY",
    "sample",
    "style",
    "tag",
    "text",
    "width"
  ],
  CanvasArc: [
    "acceleratorKey1",
    "acceleratorKey3",
    "comment",
    "diameter",
    "extentDegrees",
    "fillColor",
    "idRef",
    "name",
    "startDegrees",
    "startX",
    "startY",
    "tag"
  ],
  CanvasCircle: ["acceleratorKey1", "acceleratorKey3", "comment", "diameter", "fillColor", "idRef", "name", "startX", "startY", "tag"],
  CanvasLine: [
    "acceleratorKey1",
    "acceleratorKey3",
    "comment",
    "diameter",
    "endX",
    "endY",
    "fillColor",
    "idRef",
    "name",
    "startX",
    "startY",
    "tag",
    "width"
  ],
  CanvasOval: ["acceleratorKey1", "acceleratorKey3", "comment", "endX", "endY", "fillColor", "idRef", "name", "startX", "startY", "tag"],
  CanvasPolygon: ["acceleratorKey1", "acceleratorKey3", "comment", "fillColor", "idRef", "name", "startX", "startY", "tag", "xyList"],
  CanvasRectangle: ["acceleratorKey1", "acceleratorKey3", "comment", "endX", "endY", "fillColor", "idRef", "name", "startX", "startY", "tag"],
  CanvasText: ["acceleratorKey1", "acceleratorKey3", "anchor", "comment", "fillColor", "idRef", "name", "startX", "startY", "tag", "text"],
  CheckBox: [
    "blink",
    "bold",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "name",
    "posX",
    "posY",
    "reverse",
    "sample",
    "sizePolicy",
    "stretch",
    "stretchMin",
    "stretchMax",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "valueChecked",
    "valueUnchecked",
    "width"
  ],
  ComboBox: [
    "blink",
    "bold",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "initializer",
    "isPassword",
    "justify",
    "name",
    "placeholder",
    "posX",
    "posY",
    "queryEditable",
    "reverse",
    "sample",
    "scroll",
    "shift",
    "sizePolicy",
    "stretch",
    "stretchMin",
    "stretchMax",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "width"
  ],
  Completer: ["filterMode", "name", "size", "tag"],
  Config: ["idRef", "name", "tag"],
  DateEdit: [
    "autoNext",
    "blink",
    "bold",
    "century",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "format",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "keyboardHint",
    "maxLength",
    "name",
    "picture",
    "posX",
    "posY",
    "program",
    "reverse",
    "sample",
    "scroll",
    "shift",
    "sizePolicy",
    "stretch",
    "stretchMin",
    "stretchMax",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "verify",
    "width"
  ],
  DateTimeEdit: [
    "autoNext",
    "blink",
    "bold",
    "century",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "format",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "keyboardHint",
    "maxLength",
    "name",
    "picture",
    "posX",
    "posY",
    "program",
    "reverse",
    "sample",
    "scroll",
    "shift",
    "sizePolicy",
    "stretch",
    "stretchMin",
    "stretchMax",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "verify",
    "width"
  ],
  DefaultActions: ["idRef", "name", "tag"],
  Dialog: ["active", "idRef", "name", "tag"],
  DialogEvent: ["dialogEventItem", "dialogEventType", "idRef", "name", "tag"],
  DialogInfo: ["dialogType", "idRef", "name", "tag"],
  DragDropInfo: [
    "dndAccepted",
    "dndBuffer",
    "dndCanCopy",
    "dndCanMove",
    "dndFeedback",
    "dndIdRef",
    "dndMimeTypes",
    "dndOperation",
    "dndRequiredMimeType",
    "idRef",
    "name",
    "tag"
  ],
  Edit: [
    "autoNext",
    "blink",
    "bold",
    "century",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "format",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "keyboardHint",
    "maxLength",
    "name",
    "picture",
    "placeholder",
    "posX",
    "posY",
    "program",
    "reverse",
    "sample",
    "scroll",
    "shift",
    "sizePolicy",
    "stretch",
    "stretchMin",
    "stretchMax",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "verify",
    "width"
  ],
  XEdit: [
    "autoNext",
    "blink",
    "bold",
    "century",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "format",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "keyboardHint",
    "maxLength",
    "name",
    "picture",
    "placeholder",
    "posX",
    "posY",
    "stretchMin",
    "stretchMax",
    "program",
    "reverse",
    "sample",
    "scroll",
    "shift",
    "sizePolicy",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "verify",
    "width"
  ],
  FieldInfo: ["idRef", "name", "nodeIdRef", "tag", "targetType"],
  Folder: [
    "comment",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "name",
    "noswipe",
    "posX",
    "posY",
    "sample",
    "style",
    "tag",
    "text",
    "width"
  ],
  Form: [
    "blink",
    "bold",
    "build",
    "color",
    "delimiters",
    "dim",
    "formLine",
    "height",
    "hidden",
    "idRef",
    "image",
    "isPassword",
    "minHeight",
    "minWidth",
    "name",
    "reverse",
    "spacing",
    "sqlDbName",
    "stretch",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "version",
    "visibleId",
    "width",
    "windowStyle"
  ],
  FormField: [
    "active",
    "colName",
    "cursor",
    "cursor2",
    "defaultValue",
    "dialogType",
    "dirty",
    "fieldId",
    "hidden",
    "idRef",
    "include",
    "name",
    "noEntry",
    "notNull",
    "numAlign",
    "required",
    "screenRecord",
    "sqlTabName",
    "sqlType",
    "tabIndex",
    "tabIndexRt",
    "tag",
    "text",
    "touched",
    "unhidable",
    "unmovable",
    "unsizable",
    "unsortable",
    "value",
    "varType"
  ],
  FunctionCall: ["idRef", "isSystem", "moduleName", "name", "paramCount", "returnCount", "tag"],
  FunctionCallParameter: ["dataType", "idRef", "isNull", "name", "tag", "value"],
  Grid: [
    "comment",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "name",
    "posX",
    "posY",
    "sample",
    "style",
    "tag",
    "text",
    "width"
  ],
  Group: [
    "comment",
    "fontPitch",
    "gridChildrenInParent",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "mediaAttribute",
    "name",
    "posX",
    "posY",
    "sample",
    "style",
    "tag",
    "text",
    "width"
  ],
  GroupTitle: [],
  HBox: [
    "comment",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "mediaAttribute",
    "name",
    "noswipe",
    "orientation",
    "posX",
    "posY",
    "sample",
    "split",
    "splitter",
    "style",
    "tag",
    "text",
    "width"
  ],
  HLine: [
    "comment",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "name",
    "posX",
    "posY",
    "sample",
    "style",
    "tag",
    "text",
    "width"
  ],
  IdleAction: ["hidden", "idRef", "name", "tag", "timeout", "isTimer"],
  Image: [
    "action",
    "actionActive",
    "actionIdRef",
    "autoScale",
    "blink",
    "bold",
    "cloneColumns",
    "cloneCount",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "image",
    "isPassword",
    "justify",
    "name",
    "posX",
    "posY",
    "reverse",
    "sample",
    "sizePolicy",
    "stepX",
    "stepY",
    "stretch",
    "stretchMin",
    "stretchMax",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "width"
  ],
  ImageFonts: [],
  ImageFont: ["name", "href"],
  Item: ["idRef", "name", "tag", "text"],
  Label: [
    "blink",
    "bold",
    "cloneColumns",
    "cloneCount",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "format",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "name",
    "posX",
    "posY",
    "reverse",
    "sample",
    "sizePolicy",
    "stepX",
    "stepY",
    "stretch",
    "stretchMin",
    "stretchMax",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "width"
  ],
  Link: ["colName", "fieldIdRef", "idRef", "name", "tag"],
  Matrix: [
    "active",
    "bufferSize",
    "colName",
    "columnCount",
    "currentRow",
    "cursor",
    "cursor2",
    "defaultValue",
    "dialogType",
    "dirty",
    "fieldId",
    "hidden",
    "idRef",
    "include",
    "name",
    "noEntry",
    "notNull",
    "numAlign",
    "offset",
    "pageSize",
    "required",
    "screenRecord",
    "size",
    "sqlTabName",
    "sqlType",
    "stepX",
    "stepY",
    "tabIndex",
    "tabIndexRt",
    "tag",
    "text",
    "touched",
    "unhidable",
    "unmovable",
    "unsizable",
    "unsortable",
    "varType"
  ],
  Menu: ["active", "comment", "hidden", "idRef", "image", "name", "parent", "posY", "selection", "style", "tag", "text"],
  MenuAction: [
    "acceleratorName",
    "acceleratorName2",
    "acceleratorName3",
    "acceleratorName4",
    "active",
    "comment",
    "contextMenu",
    "context",
    "defaultView",
    "disclosureIndicator",
    "helpNum",
    "hidden",
    "idRef",
    "image",
    "isHotKey",
    "name",
    "tabIndexRt",
    "tag",
    "text",
    "validate"
  ],
  Message: [
    "blink",
    "bold",
    "color",
    "count",
    "dim",
    "gridHeight",
    "gridWidth",
    "height",
    "idRef",
    "isPassword",
    "name",
    "posX",
    "posY",
    "reverse",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "type",
    "underline",
    "width"
  ],
  Page: ["action", "actionActive", "actionIdRef", "comment", "hidden", "idRef", "image", "name", "style", "tag", "text"],
  PhantomColumn: [
    "active",
    "aggregateText",
    "aggregateType",
    "aggregateValue",
    "colName",
    "cursor",
    "cursor2",
    "defaultValue",
    "dialogType",
    "dirty",
    "fieldId",
    "hidden",
    "idRef",
    "imageColumn",
    "include",
    "name",
    "noEntry",
    "notNull",
    "numAlign",
    "required",
    "sqlTabName",
    "sqlType",
    "tabIndex",
    "tabIndexRt",
    "tag",
    "text",
    "touched",
    "unhidable",
    "unmovable",
    "unsizable",
    "unsortable",
    "varType"
  ],
  PhantomEdit: [
    "autoNext",
    "blink",
    "bold",
    "century",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "format",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "keyboardHint",
    "maxLength",
    "name",
    "picture",
    "posX",
    "posY",
    "program",
    "reverse",
    "sample",
    "scroll",
    "shift",
    "sizePolicy",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "verify",
    "width",
    "stretchMin",
    "stretchMax"
  ],
  PhantomFormField: [
    "active",
    "colName",
    "cursor",
    "cursor2",
    "defaultValue",
    "dialogType",
    "dirty",
    "fieldId",
    "hidden",
    "idRef",
    "include",
    "name",
    "noEntry",
    "notNull",
    "numAlign",
    "required",
    "screenRecord",
    "sqlTabName",
    "sqlType",
    "tabIndex",
    "tabIndexRt",
    "tag",
    "text",
    "touched",
    "unhidable",
    "unmovable",
    "unsizable",
    "unsortable",
    "value",
    "varType"
  ],
  PhantomMatrix: [
    "active",
    "bufferSize",
    "colName",
    "columnCount",
    "currentRow",
    "cursor",
    "cursor2",
    "defaultValue",
    "dialogType",
    "dirty",
    "fieldId",
    "hidden",
    "idRef",
    "include",
    "name",
    "noEntry",
    "notNull",
    "numAlign",
    "offset",
    "pageSize",
    "required",
    "screenRecord",
    "size",
    "sqlTabName",
    "sqlType",
    "stepX",
    "stepY",
    "tabIndex",
    "tabIndexRt",
    "tag",
    "text",
    "touched",
    "unhidable",
    "unmovable",
    "unsizable",
    "unsortable",
    "varType"
  ],
  ProgressBar: [
    "blink",
    "bold",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "name",
    "posX",
    "posY",
    "reverse",
    "sample",
    "sizePolicy",
    "stretch",
    "stretchMin",
    "stretchMax",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "valueMax",
    "valueMin",
    "width"
  ],
  Property: ["idRef", "name", "value"],
  PropertyArray: ["idRef", "name"],
  PropertyDict: ["idRef", "name"],
  RadioGroup: [
    "blink",
    "bold",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "name",
    "orientation",
    "posX",
    "posY",
    "reverse",
    "sample",
    "sizePolicy",
    "stretch",
    "stretchMin",
    "stretchMax",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "width"
  ],
  RecordView: ["idRef", "name", "tabName", "tag"],
  Rectangle: [
    "color",
    "comment",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "name",
    "posX",
    "posY",
    "sample",
    "style",
    "tag",
    "text",
    "width"
  ],
  RipGraphic: [
    "comment",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "name",
    "posX",
    "posY",
    "sample",
    "style",
    "tag",
    "text",
    "type",
    "width"
  ],
  RowInfo: ["idRef", "selected"],
  RowInfoList: ["idRef", "name", "tag"],
  Screen: [
    "comment",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "name",
    "posX",
    "posY",
    "sample",
    "style",
    "tag",
    "text",
    "width"
  ],
  ScrollArea: ["active", "bufferSize", "currentRow", "gridHeight", "gridWidth", "name", "offset", "pageSize", "posX", "posY", "size", "tag"],
  ScrollGrid: [
    "actionActive",
    "active",
    "bufferSize",
    "comment",
    "currentRow",
    "doubleClick",
    "filter",
    "noFilter",
    "fontPitch",
    "gridChildrenInParent",
    "gridHeight",
    "gridWidth",
    "haveRowActions",
    "height",
    "hidden",
    "idRef",
    "name",
    "offset",
    "pageSize",
    "posX",
    "posY",
    "sample",
    "size",
    "style",
    "tag",
    "text",
    "width",
    "wantFixedPageSize"
  ],
  Slider: [
    "blink",
    "bold",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "name",
    "orientation",
    "posX",
    "posY",
    "reverse",
    "sample",
    "sizePolicy",
    "stretch",
    "stretchMin",
    "stretchMax",
    "step",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "valueMax",
    "valueMin",
    "width"
  ],
  SpacerItem: ["idRef", "name", "tag"],
  SpinEdit: [
    "autoNext",
    "blink",
    "bold",
    "century",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "format",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "keyboardHint",
    "maxLength",
    "name",
    "picture",
    "posX",
    "posY",
    "program",
    "reverse",
    "sample",
    "scroll",
    "shift",
    "sizePolicy",
    "step",
    "stretch",
    "stretchMin",
    "stretchMax",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "valueMax",
    "valueMin",
    "verify",
    "width"
  ],
  Stack: ["posX", "posY", "width", "height", "gridWidth", "gridHeight", "hidden", "fontPitch", "sample", "style", "text", "comment", "name", "tag"],
  StartMenu: ["fileName", "idRef", "name", "tag", "text"],
  StartMenuCommand: ["comment", "disabled", "exec", "hidden", "idRef", "image", "name", "tag", "text", "waiting"],
  StartMenuGroup: ["disabled", "hidden", "idRef", "image", "name", "tag", "text"],
  StartMenuSeparator: ["idRef", "name", "tag"],
  Style: ["idRef", "name", "tag"],
  StyleAttribute: ["idRef", "name", "tag", "value"],
  StyleList: ["fileName", "idRef", "name", "tag"],
  Table: [
    "actionActive",
    "actionIdRef",
    "active",
    "aggregateText",
    "bufferSize",
    "comment",
    "currentColumn",
    "currentRow",
    "dialogType",
    "doubleClick",
    "expandedColumn",
    "flipped",
    "filter",
    "noFilter",
    "focusOnField",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "haveRowActions",
    "height",
    "hidden",
    "stretch",
    "stretchColumns",
    "idColumn",
    "idRef",
    "imageCollapsed",
    "imageExpanded",
    "imageLeaf",
    "isNodeColumn",
    "isTree",
    "multiRowSelection",
    "name",
    "offset",
    "pageSize",
    "parentIdColumn",
    "posX",
    "posY",
    "sample",
    "size",
    "sortColumn",
    "sortSpec",
    "sortType",
    "style",
    "tabName",
    "tag",
    "text",
    "unhidableColumns",
    "unmovableColumns",
    "unsizableColumns",
    "unsortableColumns",
    "wantFixedPageSize",
    "width"
  ],
  TableAction: ["actionIdRef", "active", "hidden", "idRef", "image", "name", "rowBound", "text"],
  TableActions: ["active", "accessoryType", "detailAction", "idRef"],
  TableColumn: [
    "active",
    "aggregateText",
    "aggregateType",
    "aggregateValue",
    "colName",
    "cursor",
    "cursor2",
    "defaultValue",
    "dialogType",
    "dirty",
    "fieldId",
    "hidden",
    "idRef",
    "imageColumn",
    "include",
    "name",
    "noEntry",
    "notNull",
    "numAlign",
    "required",
    "sqlTabName",
    "sqlType",
    "tabIndex",
    "tabIndexRt",
    "tag",
    "text",
    "touched",
    "unhidable",
    "unmovable",
    "unsizable",
    "unsortable",
    "varType"
  ],
  TextEdit: [
    "autoNext",
    "blink",
    "bold",
    "century",
    "color",
    "colorCondition",
    "comment",
    "compress",
    "dim",
    "fontPitch",
    "format",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "keyboardHint",
    "maxLength",
    "name",
    "notEditable",
    "picture",
    "posX",
    "posY",
    "program",
    "reverse",
    "sample",
    "scroll",
    "scrollBars",
    "shift",
    "sizePolicy",
    "stretch",
    "stretchMin",
    "stretchMax",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "verify",
    "wantReturns",
    "wantTabs",
    "width"
  ],
  TimeEdit: [
    "autoNext",
    "blink",
    "bold",
    "century",
    "color",
    "colorCondition",
    "comment",
    "dim",
    "fontPitch",
    "format",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "keyboardHint",
    "maxLength",
    "name",
    "picture",
    "posX",
    "posY",
    "program",
    "reverse",
    "sample",
    "scroll",
    "shift",
    "sizePolicy",
    "stretch",
    "stretchMin",
    "stretchMax",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "verify",
    "width"
  ],
  ToolBar: ["buttonTextHidden", "fileName", "idRef", "name", "style", "tag"],
  ToolBarAutoItems: ["style", "hidden", "content", "name", "tag", "mediaAttribute"],
  ToolBarItem: ["actionActive", "actionIdRef", "comment", "hidden", "idRef", "image", "name", "style", "tag", "text"],
  ToolBarSeparator: ["hidden", "idRef", "name", "style", "tag"],
  TopMenu: ["fileName", "idRef", "name", "style", "tag"],
  TopMenuAutoCommands: ["style", "hidden", "content", "name", "tag", "mediaAttribute"],
  TopMenuCommand: ["acceleratorName", "actionActive", "actionIdRef", "comment", "hidden", "idRef", "image", "name", "style", "tag", "text"],
  TopMenuGroup: ["comment", "hidden", "idRef", "image", "name", "style", "tag", "text"],
  TopMenuSeparator: ["hidden", "idRef", "name", "style", "tag"],
  TreeInfo: ["currentParentRow", "hasChildren", "idRef"],
  TreeItem: ["expanded", "hasChildren", "idRef", "row"],
  UserInterface: [
    "charLengthSemantics",
    "clickedCanvasItemId",
    "commentLine",
    "commentLineHidden",
    "container",
    "currentWindow",
    "dbCentury",
    "dbDate",
    "decimalSeparator",
    "errorLine",
    "fieldOrder",
    "fieldSelection",
    "focus",
    "formLine",
    "height",
    "idRef",
    "image",
    "inputWrap",
    "media",
    "menuLine",
    "messageLine",
    "name",
    "procId",
    "procIdParent",
    "procIdWaiting",
    "promptLine",
    "runtimeStatus",
    "tag",
    "text",
    "thousandsSeparator",
    "type",
    "uiMode",
    "width"
  ],
  VBox: [
    "comment",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "mediaAttribute",
    "name",
    "noswipe",
    "orientation",
    "posX",
    "posY",
    "sample",
    "split",
    "splitter",
    "style",
    "tag",
    "text",
    "width"
  ],
  Value: ["blink", "bold", "color", "dim", "idRef", "image", "isPassword", "name", "reverse", "tag", "ttyAttr", "underline", "value"],
  ValueList: ["idRef", "name", "tag"],
  WebComponent: [
    "blink",
    "bold",
    "color",
    "colorCondition",
    "comment",
    "componentType",
    "dim",
    "fontPitch",
    "gridHeight",
    "gridWidth",
    "height",
    "hidden",
    "idRef",
    "isPassword",
    "justify",
    "name",
    "posX",
    "posY",
    "reverse",
    "sample",
    "scrollBars",
    "sizePolicy",
    "stretch",
    "stretchMin",
    "stretchMax",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "width"
  ],
  Window: [
    "blink",
    "bold",
    "border",
    "color",
    "commentLine",
    "commentLineHidden",
    "dim",
    "errorLine",
    "formLine",
    "gridHeight",
    "gridWidth",
    "height",
    "idRef",
    "image",
    "isPassword",
    "menuLine",
    "messageLine",
    "name",
    "parent",
    "posX",
    "posY",
    "promptLine",
    "reverse",
    "style",
    "tag",
    "text",
    "ttyAttr",
    "underline",
    "width",
    "windowType"
  ]
};
